import React from 'react';
import { Button, Form } from 'antd';
import TextInput from '../inputs/TextInput';
import DateInput from '../inputs/DateInput';
import useTranslation from '../../hooks/translation/useTranslation';

function TicketsSearchForm({ onFinish, form }) {
  const { trans } = useTranslation();
  return (
    <Form onFinish={onFinish} layout="vertical" className="grid grid-cols-3 gap-x-4 " form={form}>
      <DateInput label={trans('ride_start_date_time')} name="date_time" />
      <TextInput label={trans('ticket_owner')} name="name" />
      <TextInput label={trans('ride_id')} name="ride_id" />
      <TextInput label={trans('user')} name="customer" />
      <TextInput label={trans('ticket_number')} name="ticket_number" />
      <TextInput label={trans('statement_code')} name="statement_id" />
      <Form.Item label=" " className="w-full">
        <Button className="w=full" type="primary" htmlType="submit">{trans('search')}</Button>
      </Form.Item>
    </Form>
  );
}

export default TicketsSearchForm;
